var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPhaseAutomation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35941 6.3785C3.8623 6.37819 3.38541 6.57531 3.03359 6.92651C2.68238 7.27833 2.48527 7.75522 2.48558 8.25233V15.7477C2.48471 16.2461 2.68232 16.7243 3.03475 17.0767C3.38718 17.4292 3.86542 17.6268 4.36383 17.6259L16.3051 17.6259C16.8022 17.6262 17.2791 17.4291 17.6309 17.0779L21.383 13.3258C22.1152 12.5936 22.1152 11.4064 21.383 10.6742L17.6309 6.92209C17.2791 6.57089 16.8022 6.37377 16.3051 6.37408L4.35941 6.3785ZM20.4991 11.5581C20.7432 11.8021 20.7432 12.1979 20.4991 12.4419L16.747 16.194C16.6284 16.3116 16.4677 16.3769 16.3007 16.3752L4.35941 16.3752C4.01569 16.3742 3.7373 16.0958 3.73627 15.7521V8.24792C3.7373 7.90419 4.01569 7.6258 4.35941 7.62478L16.3007 7.62478C16.4677 7.6231 16.6284 7.68836 16.747 7.80597L20.4991 11.5581Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.35714V6.64286H13.5714C13.5 6.21429 13.2143 5.42857 13 5L14.0714 3.92857L13.0714 2.92857L12 4C11.6429 3.78571 11.2143 3.57143 10.7143 3.5V2H9.28571V3.5C8.85714 3.57143 8.42857 3.78571 8 4L6.92857 2.92857L5.92857 3.92857L7 5C6.78571 5.35714 6.5 6.14286 6.42857 6.64286H5V7.35714H6.42857C6.5 7.78571 6.78571 8.57143 7 9L5.92857 10.0714L6.92857 11.0714L8 10C8.35714 10.2143 8.78571 10.4286 9.28571 10.5V12H10.7143V10.5C11.1429 10.4286 11.5714 10.2143 12 10L13.0714 11.0714L14.0714 10.0714L13 9C13.2143 8.64286 13.5 7.85714 13.5714 7.35714H15ZM10 9.14286C8.78571 9.14286 7.85714 8.21429 7.85714 7C7.85714 5.78571 8.78571 4.85714 10 4.85714C11.2143 4.85714 12.1429 5.78571 12.1429 7C12.1429 8.21429 11.2143 9.14286 10 9.14286Z",
    fill: "black"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgPhaseAutomation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phase-automation.01ff26b46de97f41f582e12b8b5af50c.svg";